import LayersIcon from '@mui/icons-material/Layers';

import { DrawingManagerContext } from '../../context/drawing-manager-context.js';
import { ToolbarItem } from '../toolbar-item.js';
import { LayersView } from './layers-view.js';

import type { ElementType } from 'react';
import type { DrawingManagerContextValue } from '../../context/drawing-manager-context.js';
import type { IToolbarItem, IToolbarItemState } from '../toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

export class LayersToolbarItem extends ToolbarItem<IOwnState> implements IToolbarItem {
	public static readonly ItemId = 'layerpanel';
	id: string = LayersToolbarItem.ItemId;
	title = 'Drawing layers';
	keyEventName = 'DRAWING_LAYERS';
	defaultKeyBinding = 'l';
	iconElement: ElementType = LayersIcon;
	includeInHistory = false;
	// @ts-expect-error
	context: DrawingManagerContextValue | undefined;

	public onActiveStateChanged() {
		// Empty on purpose
	}

	public onKeyEvent(): void {
		// Empty on purpose
	}

	public onClick(): void {
		// Empty on purpose
	}

	protected override renderActive = (isActive: boolean) => {
		if (!isActive || !this.ref.current) {
			return null;
		}

		return (
			<LayersView
				anchorEl={this.ref.current}
				onClose={() => this.maybeDeactivate()}
				layerStatesChanged={(states) => this.emitToolUsed({ states })}
			/>
		);
	};
}

LayersToolbarItem.contextType = DrawingManagerContext;
